import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {LibraryLayout} from '$pages/$library/library-layout';
import LibrarySearchForm from '$pages/$library/$';
import LibrarySearchResults from '$pages/$library/$search';

export const libraryRoute = (
  <Route path="library" component={LibraryLayout}>
    <IndexRoute component={LibrarySearchForm} />
    <Route path="search(/:libraryId)" component={LibrarySearchResults} />
  </Route>
);
